import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import BlogList from "./components/BlogList";
import BlogPost from "./components/BlogPost";
import CampaignLanding from "./components/CampaignLanding";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import { captureUtmParams } from "./utils/utm";

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return null;
}

export default function App() {
  useEffect(() => {
    captureUtmParams();
  }, []);

  return (
    <main className="text-gray-600 bg-white body-font">
      <ScrollToHash />
      <Navbar />
      <Switch>
        <Route exact path="/blog" component={BlogList} />
        <Route exact path="/blog/:slug" component={BlogPost} />
        <Route exact path="/for/:slug" component={CampaignLanding} />
        <Route exact path="/" component={Home} />
      </Switch>
      <Footer />
    </main>
  );
}
